import Hero from "../components/Hero.jsx";
import PageSections from "../components/PageSections.jsx";

export default function LandingPage({ page }) {
  return (
    <>
      <Hero hero={page?.hero} />
      <PageSections sections={page?.sections} />
    </>
  );
}
